export interface RichTextAttributes {
  bold?: true
  italic?: true
  underline?: true
  color?: string
}

export interface RichTextOperation {
  insert: string
  attributes?: RichTextAttributes
}

export interface RichTextInstructions {
  version: 1
  ops: RichTextOperation[]
}

export const TASK_INSTRUCTIONS_MAX_LENGTH = 5000

export const getInstructionsText = (instructions?: RichTextInstructions | null): string => {
  if (!instructions) return ''
  const text = instructions.ops.map(operation => operation.insert).join('')
  return text.endsWith('\n') ? text.slice(0, -1) : text
}

export const createPlainInstructions = (text?: string | null): RichTextInstructions | null => {
  if (!text) return null
  return {version: 1, ops: [{insert: `${text}\n`}]}
}

export const normalizeInstructions = (
  instructions?: RichTextInstructions | string | null
): RichTextInstructions | null =>
  typeof instructions === 'string' ? createPlainInstructions(instructions) : instructions || null
